/**
 * Send a transactional email, as the signed-in user.
 *
 * Replaces direct POSTs to the `sendMailgunEmail` Cloud Function, which has NO
 * authentication: open CORS, no token check, no origin restriction. Because the
 * app built that URL client-side it shipped in the public bundle, so anyone who
 * looked could send arbitrary HTML to any address FROM the Cuelist Mailgun
 * domain -- mail that passes SPF and DKIM as genuine.
 *
 * `httpsCallable` attaches and verifies the caller's Firebase ID token, so the
 * function can require `context.auth`. That is the whole fix; nothing else about
 * the send changes.
 *
 * Same shape as the old POST body, so call sites change by one line.
 */
import firebase from 'firebase/app';
import 'firebase/functions';

export function sendMail({ email, subject, content }) {
    return firebase.functions().httpsCallable('sendTransactionalEmail')({ email, subject, content });
}

export default sendMail;


// WEBPACK FOOTER //
// ./src/lib/sendMail.js